export default __webpack_public_path__ + "static/media/logo1_noBackground1.f9adac2f.png";